module.exports = __webpack_public_path__ + "static/media/byob.a659715d.svg";